<template>
  <div class="row">
    <div class="col-sm-12">
      <h2 class="section-header">
        Your GradReel Video
      </h2>

      <div class="row">
        <div class="col-xs-12 col-sm-5">

          <img :src="videoinfo.ThumbnailPath">
        </div>
        <div class="col-xs-12 col-sm-7">
          <div>
            <div class="motion-product__lede">
              Congratulations! Celebrate with our Gif(t) to you, your GradReel Video. Share your video with your family and friends on social media.
            </div>

            <div class="row">
              <div class="col-xs-12 col-md-5">
                <a
                  href="#"
                  class="button motion-product__view-share-button"
                  @click.prevent="handleViewShareButtonClick"
                >
                  <div>VIEW AND SHARE</div>
                </a>
              </div>
              <div class="col-xs-12 col-md-7">
                <a
                  :href="videoinfo.VideoURL"
                  class="button motion-product__download-button"
                  download
                >
                  <div>DOWNLOAD YOUR STORY</div>
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
    <motion-product-modal
      :product="videoinfo"
      :show="showShareModal"
      @modal-close="showShareModal = false"
    />
  </div>
</template>
<script>
import motionProductMixin from './MotionProduct/mixin'
import GoogleAnalytics from '@Shared/lib/google-analytics'
import MotionProductModal from './MotionProduct/MotionProductModal'

export default {
  name: 'GradReelVideo',
  components: {
    MotionProductModal
  },
  mixins: [
    motionProductMixin
  ],
  props: {
    videoinfo: { type: Object, default: null, required: true }
  },
  data () {
    return {
      showShareModal: false
    }
  },
  methods: {
    handleViewShareButtonClick () {
      this.showShareModal = true

      GoogleAnalytics.trackEvent(
        'Personalized Ceremony Video',
        'click',
        'View & Share'
      )
    }
  }

}
</script>
<style lang="scss" scoped>
  .motion-product {
    &__lede {
      font-size: 16px;
      margin: 0 0 20px 0;
      text-align: center;
    }

    &__thumb-img {
      margin-bottom: 20px;
      width: 100%;
    }

    &__view-share-button {
      background-color: #fff;
      border: 2px solid $grad-color-blue;
      color: $grad-color-blue;
      font-size: 20px;
      font-weight: bold;
      line-height: 2.5;
      margin: 0 0 20px 0;
      text-align: center;
      width: 100%;
    }

    &__download-button {
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      width: 100%;
    }

    @media screen and (min-width: $screen-sm-min) {
      &__lede {
        text-align: left;
      }
    }

    @media screen and (min-width: $screen-md-min) {
      &__thumb-img {
        width: 385px;
      }

      &__view-share-button {
        margin: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/checkout-download/components/GradReelVideo.vue